import { FileTextTwoTone, FileTwoTone } from "@ant-design/icons";
import { useMutation } from "@tanstack/react-query";
import { Button, Modal } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useAuthenticatedRequestCreator } from "hooks/useRequests";
import { StaffUsersProfile } from "hooks/useUsers";
import { useState } from "react";

const useUserNotes = () => {
    const post = useAuthenticatedRequestCreator<void, { userId: string, notes: string | null }>(
        (data) => ({
            method: "post",
            url: "/account/notes",
            data
        })
    );

    const { mutateAsync: updateNotes, isLoading } = useMutation(post);

    return { updateNotes, isLoading };
}

const UserNotesModal = (props: {
    user: StaffUsersProfile,
    onSuccess: () => Promise<void>,
}) => {
    const { user, onSuccess } = props;
    const [open, setOpen] = useState(false);
    const [notes, setNotes] = useState(user.notes);
    const { updateNotes, isLoading } = useUserNotes();

    const icon = user.notes
        ? <FileTextTwoTone />
        : <FileTwoTone />;

    const cancel = () => {
        setOpen(false);
        setNotes(user.notes);
    }

    const ok = async () => {
        await updateNotes({ userId: user.id, notes });
        setOpen(false);
        await onSuccess();
    }

    return <>
        <Button type="text" icon={icon} onClick={() => setOpen(true)} />
        <Modal
            title={`User Notes - ${user.userName}`}
            closable={false}
            keyboard={false}
            maskClosable={false}
            destroyOnClose={true}
            open={open}
            confirmLoading={isLoading}
            onOk={async () => await ok()}
            onCancel={cancel}
            cancelButtonProps={{ disabled: isLoading }}
        >
            <label htmlFor="user-notes">Notes entered here will show up when the user is selected on the package creation form.</label>
            <TextArea
                id="user-notes"
                value={notes ?? ''}
                onChange={(e) => setNotes(e.target.value)}
                rows={10}
                allowClear
                style={{ marginTop: '15px' }}
                disabled={isLoading}
                autoFocus
            />
        </Modal>
    </>;
}

export default UserNotesModal;